import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GlobalProvider } from './context/GlobalContext';
import './i18n';
import HeadManager from './HeadManager';
import { CartProvider } from './context/CartContext';
import { PaymentProvider } from './context/PaymentContext';
import { HelmetProvider } from 'react-helmet-async';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <GlobalProvider>
      <CartProvider>
      <PaymentProvider>
        <HeadManager />
        <App />
        </PaymentProvider>
      </CartProvider>
    </GlobalProvider>
  </HelmetProvider>
);

reportWebVitals();